export const RequestType = {
    0: 'Unknown',
    1: 'SelfOnboarding',
    2: 'ProjectResourceAssignment',
    3: 'HEAppECreation',
} as const;

export type RequestTypeKey = keyof typeof RequestType;
